import type { JobModulesTableColumn } from "./job-modules-table.type";

import { Tooltip } from "antd";
import { useTranslation } from "react-i18next";

import { REFERENTIAl_STATES_ENDPOINT } from "@/entities/referential/referential-states";
import { CauserSubject } from "@/modules/causer-subject";
import { DocumentsDownloadButton } from "@/modules/documents/documents-download-button";
import ListTable from "@/modules/list-table";
import { StateTag } from "@/modules/state-tag";
import { useTableFilterReferentialStates } from "@/modules/table-filter";
import { format, fromNow } from "@/utilities/date";

import "./job-modules-table.style.less";

const JobModulesTable = () => {
  const { t } = useTranslation();

  const statesFilter = useTableFilterReferentialStates(
    REFERENTIAl_STATES_ENDPOINT.JOB_MODULE
  );
  const columns: JobModulesTableColumn[] = [
    {
      title: t("jobModule:source"),
      dataIndex: "module_source",
      render: (_, { module_source }) => {
        const { name, description } = module_source ?? {};
        return description ? (
          <Tooltip title={description}>{name}</Tooltip>
        ) : (
          name
        );
      },
    },
    {
      title: t("global:status"),
      dataIndex: "state",
      render: (_, { state }) => <StateTag value={state} type="job_module" />,
      ...statesFilter,
    },
    {
      title: t("jobModule:executedAt"),
      dataIndex: "started_at",
      render: (_, { started_at }) => {
        if (started_at) {
          return (
            <Tooltip title={format(started_at, "LLLL")}>
              {fromNow(started_at)}
            </Tooltip>
          );
        }
      },
      sorter: true,
    },
    {
      title: t("jobModule:causer"),
      dataIndex: "causer",
      render: (_, { causer }) => (
        <CauserSubject type="causer" model="user" item={causer} />
      ),
    },
    {
      title: t("global:documentPlural"),
      dataIndex: "documents",
      render: (_, { documents }) => (
        <DocumentsDownloadButton documents={documents} />
      ),
    },
  ];

  return (
    <div className="job-modules-table">
      <ListTable modelKey="jobmodule" columns={columns} />
    </div>
  );
};

export default JobModulesTable;
